import * as React from 'react';
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import './ObjectIcons.scss';

const ObjectIcon = ({ objectApiName, className }) => {
  const objectIcons = useSelector((state) => state.mail.icons);
  const [imageUrl, setImage] = useState('');
  const [color, setColor] = useState('');

  const getImageUrl = () => {
    const theme = objectIcons[objectApiName];
    if (theme) {
      return { imageUrl: theme.url, color: `#${theme.color}` };
    }
    return '../../../../assets/other.svg';
  };

  useEffect(() => {
    const { imageUrl, color } = getImageUrl();
    setImage(imageUrl);
    setColor(color);
  }), [objectIcons];

  return (
    <img
      id={className}
      src={imageUrl}
      className={`objectIcon ${className}`}
      style={{ backgroundColor: color }}
    />
  );
};

ObjectIcon.propTypes = {
  objectApiName: PropTypes.string,
  className: PropTypes.string,
};

export default ObjectIcon;
